<template>
  <div class="tw-w-full">
    <slot />
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
